/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Section_WordInputs */

const en_highlight_settings_section_word = /** @type {(inputs: Highlight_Settings_Section_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section + word`)
};

const es_highlight_settings_section_word = /** @type {(inputs: Highlight_Settings_Section_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sección + palabra`)
};

/**
* | output |
* | --- |
* | "Section + word" |
*
* @param {Highlight_Settings_Section_WordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_section_word = /** @type {((inputs?: Highlight_Settings_Section_WordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Section_WordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_section_word(inputs)
	return en_highlight_settings_section_word(inputs)
});